export default `
  <form class="site-header-all-results">
    <div  class="all-results-modal">
        <div class="exit-all-result">
            <span class="exit-results-modal icon-delete"></span>
        </div>
        <div class="all-results-container">
            <div class="all-result-header">
                <span class="all-results-headline">Search Results</span>
                    <div class="all-results-category"></div>
            </div>
            <ul class="search-results-all"></ul>
        </div>
        <div class="pagination-container"></div>
    </div>
  </form>
`;
